import styled from 'styled-components';

import { Theme } from '@commons/utils/theme';

export const Container = styled.div`
  position: fixed;

  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  background-color: ${(props) => props.theme.colors.greys.darkest};
`;

export const Logo = styled.img`
  width: 64px;
  height: 64px;
`;

export const TextContainer = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const getButtonStyle = (theme: Theme) => ({
  backgroundColor: theme.colors.greys.dark,
  color: theme.colors.greys.lightest,
  borderRadius: '24px',
  textTransform: 'none',
  transition: 'color 0.3s ease, border-color 0.3s ease',
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  '&:hover': {
    backgroundColor: theme.colors.greys.darker
  }
});
